<template>
	<div class="lands-wrapper">
		<div class="login-img" @click="$router.push('/')">
			<img src="@/assets/images/registerLogin.png" alt="">
		</div>
		<div class="land-content">
			<div class="land-left">
				<div class="merchant-login">商戶登入</div>
				<div class="no-account">未有帳戶？
					<router-link to="/register"><label class="create-accounts">建立帳戶</label></router-link>
				</div>
				<div class="phone-label">電郵</div>
				<input type="text" id="email" v-model="email" @input="validateEmail" class="phone-input" />
				<div for="password" class="password-label">密碼</div>
				<input type="text" id="password" v-model="password" @input="validatePassword" class="password-input" />
				<div class="forgot-password">忘記密碼</div>
				<div class="login-button">登入</div>
				<div class="line-text-line">
					<span class="line"></span>
					<span class="text">沒有帳號？</span>
					<span class="line"></span>
				</div>
				<router-link to="/register">
					<div class="create-account">建立帳戶</div>
				</router-link>

			</div>
			<div class="land-password-image">
				<video ref="video-1" muted preload autoplay loop controls="false" id="myVideo" type="video/mp4" width="100%"
					webkit-playsinline="true" x-webkit-airplay="allow" playsinline="" x5-video-player-type="h5"
					x5-video-orientation="portrait" x5-video-player-fullscreen="portraint"
					src="@/assets/images/login_video.mp4">
					对不起，您的手机不支持本系统
				</video>
			</div>
		</div>
		<BaseFooter></BaseFooter>
	</div>
</template>
<script>
export default {
	data() {
		return {
			videoList: ['video-1']
		}
	},
	mounted() {
		this.videoList.forEach(i => {
			this.$refs[i].controls = false
		})
	},
}
</script>
<style lang="scss" scoped>
.lands-wrapper {
	padding: 0.24rem 0.24rem 0.24rem 0.4rem;
	// height: 100vh;

	.login-img {
		height: 0.48rem;
		position: absolute;
		left: 0.4rem;
		cursor: pointer;

		img {
			height: 100%;
			display: block;
		}
	}

	.land-content {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		width: 100%;
		height: 100%;

		.land-left {
			margin-right: 3.02rem;
			height: 100%;

			.merchant-login {
				font-family: 'PingFang HK';
				font-style: normal;
				font-weight: 600;
				font-size: 0.40rem;
				line-height: 0.56rem;
				color: #000000;
				margin-bottom: 0.16rem;
				padding-top: 1.8rem;
			}

			.no-account {
				font-family: 'PingFang HK';
				font-style: normal;
				font-weight: 400;
				font-size: 0.20rem;
				line-height: 0.28rem;
				color: #666666;
				margin-bottom: 0.64rem;
			}

			.create-accounts {
				font-family: 'PingFang HK';
				font-style: normal;
				font-weight: 600;
				font-size: 0.20rem;
				line-height: 0.28rem;
				text-decoration-line: underline;
				color: #E02E43;
				cursor: pointer;
			}

			.phone-label {
				font-family: 'PingFang HK';
				font-style: normal;
				font-weight: 400;
				font-size: 0.20rem;
				line-height: 0.28rem;
				color: #000000;
			}

			.password-label {
				font-family: 'PingFang HK';
				font-style: normal;
				font-weight: 400;
				font-size: 0.20rem;
				line-height: 0.28rem;
				color: #000000;

			}

			.phone-input {
				width: 5.22rem;
				height: 0.56rem;
				background: #FAFAFA;
				border: 1px solid #999999;
				border-radius: 0.08rem;
				display: block;
				margin-top: 0.08rem;
				margin-bottom: 0.24rem;
				padding: 0 0.3rem;
			}

			.password-input {
				width: 5.22rem;
				height: 0.56rem;
				background: #FAFAFA;
				border: 1px solid #999999;
				border-radius: 0.08rem;
				display: block;
				margin-top: 0.08rem;
				margin-bottom: 0.24rem;
				padding: 0 0.3rem;
			}

			.forgot-password {
				font-family: 'PingFang HK';
				font-style: normal;
				font-weight: 400;
				font-size: 16px;
				line-height: 22px;
				text-decoration-line: underline;
				color: #666666;
				cursor: pointer;
			}

			.login-button {
				background: #E02E43;
				border-radius: 0.08rem;
				width: 5.22rem;
				font-family: 'PingFang HK';
				font-style: normal;
				font-weight: 600;
				font-size: 0.24rem;
				line-height: 0.32rem;
				color: #FFFFFF;
				text-align: center;
				margin-top: 0.64rem;
				padding: 0.24rem 0;
			}

			.line-text-line {
				display: flex;
				align-items: center;
				margin: 0.24rem 0rem;

				.line {
					flex-grow: 1;
					border-top: 1px solid black;
				}

				.text {
					padding: 0 10px;
					font-family: 'PingFang HK';
					font-style: normal;
					font-weight: 400;
					font-size: 0.16rem;
					line-height: 0.32rem;
					color: #000000;
				}
			}

			.create-account {
				background: #FFFFFF;
				border-radius: 0.08rem;
				width: 5.22rem;
				font-family: 'PingFang HK';
				font-style: normal;
				font-weight: 600;
				font-size: 0.24rem;
				line-height: 0.32rem;
				color: #E02E43;
				text-align: center;
				margin-top: 0.40rem;
				padding: 0.24rem 0;
				border: 1px solid #E02E43;
				cursor: pointer;
			}
		}

		.land-password-image {
			width: 7.76rem;
			border-radius: 0.3rem;
			overflow: hidden;
			height: 100%;

			img {
				width: 100%;
				height: 100%;
				display: block;
				object-fit: cover;
			}

			#myVideo {
				width: 100%;
				height: 100%;
				display: block;
				object-fit: cover;
			}

			//所有控件
			video::-webkit-media-controls-enclosure {
				display: none;
			}
		}
	}
}

@media (max-width: 750px) {
	.lands-wrapper .land-content .land-password-image {
		display: none;
	}

	.lands-wrapper .land-content {
		display: block;
	}

	.lands-wrapper .login-img {
		height: 0.8rem;
	}

	.lands-wrapper {
		padding: 0.4rem;
	}

	.lands-wrapper .land-content .land-left {
		margin: 0;
	}

	.lands-wrapper .land-content .land-left .phone-label {
		font-size: 0.32rem;
		line-height: 0.32rem;
		margin-bottom: 0.2rem;
	}

	.lands-wrapper .land-content .land-left .phone-input {
		width: 100%;
		height: 0.9rem;
	}

	.lands-wrapper .land-content .land-left .password-input {
		width: 100%;
		height: 0.9rem;
	}

	.lands-wrapper .land-content .land-left .login-button {
		width: 100%;
		height: 1rem;
		padding: 0;
		line-height: 1rem;
		border-radius: 0.16rem;
		font-size: 0.4rem;
	}

	.lands-wrapper .land-content .land-left .create-account {
		width: 100%;
		height: 1rem;
		padding: 0;
		line-height: 1rem;
		border-radius: 0.16rem;
		font-size: 0.4rem;
	}
}
</style>